module.exports = __webpack_public_path__ + "media/images/assign-schedule-40410bb5cdafc5ec7ee8234947602603.svg";